import $ from 'jquery';

/**
 * @desc Manages 'Copy To Clipboard' functionality.
 * @see {@link https://clipboardjs.com/}
 */
// TODO: Move magic css classes to a config object
export default class CopyToClipboard {
  constructor(copyButtonSelector = '.js-copy-to-clipboard') {
    this.copyButtonList = document.querySelectorAll(copyButtonSelector);

    this.init();
  }

  async init() {
    this.isInitialized = true;

    if (!this.copyButtonList.length) {
      this.isInitialized = false;

      return;
    }

    try {
      const { default: ClipboardJS } = await import('clipboard');
      const clipboard = new ClipboardJS(this.copyButtonList);

      clipboard.on('success', (event) => {
        const $triggerElement = $(event.trigger);

        $triggerElement.addClass('is-copied');

        setTimeout(() => {
          $triggerElement.removeClass('is-copied');
        }, 1000);
      });
    } catch (error) {
      console.error(`An error was occured during initialization ClipboardJS: ${error}`);
    }
  }
}
